<template>
  <div>
    <b-navbar>
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img
              src="https://www.cen-nouvelle-aquitaine.org/logo_cenna.jpg"
              alt="ProgCEN"
          >
        </b-navbar-item>
      </template>
      <template slot="start">

        <b-navbar-item
            v-if="isAuth"
        >
          <b-select placeholder="Sélectionner un exercice"
                    @input="dbSwitch()"
                    v-model="dbSelected">
            <option
                v-for="option in dblist"
                :value="option"
                :key="option"
                >
              {{ option }}
            </option>
          </b-select>

        </b-navbar-item>

        <!-- Programmation -->
        <b-navbar-dropdown
            label="Programmation budgétaire"
            v-if="isAuth">
          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/liste' }"
          >
            Liste
          </b-navbar-item>

          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/projet' }"
          >
            Saisie
          </b-navbar-item>

          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/import' }"
          >
            Import
          </b-navbar-item>

          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/charge' }"
          >
            Charge
          </b-navbar-item>

            <b-navbar-item
                v-if="isAuth"
                tag="router-link"
                :to="{ path: '/tableau-phase' }"
            >
                Tableau Phase
            </b-navbar-item>

          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/tableau-financier' }"
          >
            Tableau financier
          </b-navbar-item>

          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/tableau-financeur' }"
          >
            Tableau financeurs
          </b-navbar-item>

          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/marges' }"
          >
              Marges et services supports
          </b-navbar-item>

          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/export' }"
          >
            Export
          </b-navbar-item>

          <b-navbar-item
              v-if="isAuth && hasMarge"
              tag="router-link"
              :to="{ path: '/migration' }"
          >
            Migration salariés
          </b-navbar-item>
        </b-navbar-dropdown>

        <!-- Export des feuilles de temps -->
        <b-navbar-dropdown
            label="Export de l'ERP"
            v-if="isAuth">

          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/exportfdt' }"
          >
            Feuille de temps ERP
          </b-navbar-item>

        </b-navbar-dropdown>

        <!-- Rapports -->
        <b-navbar-dropdown
            label="Tableaux de bord"
            v-if="isAuth"
            >

          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/tablesuivirt' }"
          >
            Suivi temps réel
          </b-navbar-item>

            <b-navbar-item
                v-if="isAuth"
                tag="router-link"
                :to="{ path: '/weektimesheet' }"
            >
                État des feuilles de temps
            </b-navbar-item>

          <b-navbar-item
              v-if="isAuth"
              tag="router-link"
              :to="{ path: '/reconciliationfdtfrais' }"
          >
            Réconciliation FDT / Frais
          </b-navbar-item>


        </b-navbar-dropdown>


      </template>

      <template slot="end">
        <b-navbar-item tag="div">

          <b-button
              v-if="!isAuth"
              type="is-primary"
              @click="loginModal()">
            <strong>Connexion</strong>
          </b-button>

          <b-button
              v-if="isAuth && sandboxMode"
              type="is-danger"
              @click="confirmReset()"
              style="margin-right: 8px; font-weight: bold;"
          >
            <b-icon icon="exclamation-triangle" size="is-small"></b-icon>
            <span>REINITIALISER MES DONNEES</span>
          </b-button>

          <b-button
              v-if="isAuth"
              type="is-success"
              @click="logout()"
          >
            <strong>Se déconnecter de {{ userName }}</strong>
          </b-button>

        </b-navbar-item>
      </template>
    </b-navbar>

    <b-modal :active.sync="isModalLogin" has-modal-card>
      <Login
          @auth="setAuth"
      ></Login>
    </b-modal>

  </div>
</template>

<script>

import Login from "./Login";

export default {
  name: "TopNavBar",
  components: {Login},
  mounted() {
    this.amIAuth();
    this.checkSandbox();
  },
  methods: {
    dbSwitch() {
      // console.log(this.dbSelected);
      localStorage.setItem("dbSelected", this.dbSelected);
      window.location.reload();
    },
    amIAuth() {
      this.$axios.get('me', {})
          .then((res) => {
            if (res.data.success) {
              this.isAuth = true;
              this.userName = res.data.user;
              this.hasMarge = res.data.rights && res.data.rights.marge;
              this.$axios.get('listdatabases', {})
                  .then((db) => {
                    this.dblist = db.data.dblist;
                    // Bugfix : deal with stucked data in localstorage
                    const saved = localStorage.getItem("dbSelected");
                    if (saved && saved !== "undefined" && db.data.dblist.includes(saved)) {
                      this.dbSelected = saved;
                    } else {
                      this.dbSelected = process.env.VUE_APP_CURRENTDB;
                      localStorage.setItem("dbSelected", process.env.VUE_APP_CURRENTDB);
                    }
                  });
            }
          });
    },
    logout() {
      this.$axios.get('logout', {})
          .then((res) => {
            if (res.data.success) {
              // TODO check
              document.cookie = "SID= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
              this.isAuth = false;
              this.userName = '';
              this.$router.push('/').catch(() => {
              })
            }
          });
    },
    setAuth(res) {
      this.isModalLogin = false;
      this.isAuth = res.success
      if (res.success) {
        //this.userName = res.user;
        this.amIAuth();
      }
    },
    loginModal() {
      this.isModalLogin = true
    },
    checkSandbox() {
      this.$axios.get('sandbox/status')
          .then((res) => {
            this.sandboxMode = res.data.sandboxMode;
          })
          .catch(() => {
            this.sandboxMode = false;
          });
    },
    confirmReset() {
      this.$buefy.dialog.confirm({
        title: 'Reinitialiser mes donnees',
        message: 'Toutes vos donnees de test seront supprimees et la base sera recree avec les referentiels par defaut. Continuer ?',
        confirmText: 'Reinitialiser',
        cancelText: 'Annuler',
        type: 'is-warning',
        onConfirm: () => {
          this.$axios.post('sandbox/reset')
              .then((res) => {
                if (res.data.success) {
                  this.$buefy.toast.open({
                    message: 'Donnees reinitialisees avec succes !',
                    type: 'is-success',
                    duration: 3000
                  });
                  setTimeout(() => window.location.reload(), 1500);
                }
              })
              .catch(() => {
                this.$buefy.toast.open({
                  message: 'Erreur lors de la reinitialisation',
                  type: 'is-danger',
                  duration: 5000
                });
              });
        }
      });
    }
  },
  data() {
    return {
      isModalLogin: false,
      userName: '',
      isAuth: false,
      hasMarge: false,
      sandboxMode: false,
      dblist: [],
      dbSelected: null,
    }
  }
}
</script>

<style scoped>

</style>
